"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let ExchangeRateFieldset = class ExchangeRateFieldset extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    getInternalItem(...args) {
        if (!this.__item) {
            this.__item = { value: null, date: null, source: null };
        }
        return this.__item;
    }
    syncExchangeRate(...args) {
        const v = this.internalItem;
        const value = v.value == null ? null : _.clone(v);
        this.$emit('input', value.value);
        console.log('$emit.input', value);
    }
    value;
    onValue(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("value");
    }
    readonly;
    onReadonly(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("readonly");
    }
    labelAlign;
    internalItem;
    async $$load_internalItem() {
        return this.getInternalItem();
    }
    exchangeRateSources;
    async $$load_exchangeRateSources() {
        return this.$app.repo.get('ui_metadata', { path: 'exchange_rate_source_options' });
    }
    ux;
    dataMembers = ['labelAlign', 'internalItem', 'exchangeRateSources', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                labelAlign: "right",
                internalItem: null,
                exchangeRateSources: null,
                ux: null,
            },
        };
    }
    get item() {
        if (this.loaded) {
            return (console.log('computed', this.value), _.assign(this.internalItem, this.value));
        }
        return null;
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_6466705138206980_script_2904_getActionArgs_value($event) {
        this.syncExchangeRate();
    }
    async act_6466705138206980_script_2904_getActionArgs($event) {
        return {
            value: () => this.act_6466705138206980_script_2904_getActionArgs_value($event),
        };
    }
    async evh_6466705138206980_blur(event, scope) {
        return await this.actions.evh_6466705138206980_blur.executeFromDOM(this, event, scope);
    }
    async act_3943151158818434_script_2906_getActionArgs_value($event) {
        this.syncExchangeRate();
    }
    async act_3943151158818434_script_2906_getActionArgs($event) {
        return {
            value: () => this.act_3943151158818434_script_2906_getActionArgs_value($event),
        };
    }
    async evh_3943151158818434_blur(event, scope) {
        return await this.actions.evh_3943151158818434_blur.executeFromDOM(this, event, scope);
    }
    async act_4207795475682514_script_2908_getActionArgs_value($event) {
        this.syncExchangeRate();
    }
    async act_4207795475682514_script_2908_getActionArgs($event) {
        return {
            value: () => this.act_4207795475682514_script_2908_getActionArgs_value($event),
        };
    }
    async evh_4207795475682514_blur(event, scope) {
        return await this.actions.evh_4207795475682514_blur.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_2902 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_2901 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_2902,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_2901],
        });
        const act_6466705138206980_script_2904 = new core_1.actions.ScriptAction({
            actionArgs: this.act_6466705138206980_script_2904_getActionArgs,
            events: [],
        });
        const evh_6466705138206980_blur_2903 = new core_1.actions.EventHandlerImpl({
            action: act_6466705138206980_script_2904,
            event: "blur",
            displayName: "script",
        });
        const evh_6466705138206980_blur = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6466705138206980_blur_2903],
        });
        const act_3943151158818434_script_2906 = new core_1.actions.ScriptAction({
            actionArgs: this.act_3943151158818434_script_2906_getActionArgs,
            events: [],
        });
        const evh_3943151158818434_blur_2905 = new core_1.actions.EventHandlerImpl({
            action: act_3943151158818434_script_2906,
            event: "blur",
            displayName: "script",
        });
        const evh_3943151158818434_blur = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3943151158818434_blur_2905],
        });
        const act_4207795475682514_script_2908 = new core_1.actions.ScriptAction({
            actionArgs: this.act_4207795475682514_script_2908_getActionArgs,
            events: [],
        });
        const evh_4207795475682514_blur_2907 = new core_1.actions.EventHandlerImpl({
            action: act_4207795475682514_script_2908,
            event: "blur",
            displayName: "script",
        });
        const evh_4207795475682514_blur = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4207795475682514_blur_2907],
        });
        return {
            act_7315092382398562_reloadComponentData_2902,
            evh_7315092382398562_reload_2901,
            evh_7315092382398562_reload,
            act_6466705138206980_script_2904,
            evh_6466705138206980_blur_2903,
            evh_6466705138206980_blur,
            act_3943151158818434_script_2906,
            evh_3943151158818434_blur_2905,
            evh_3943151158818434_blur,
            act_4207795475682514_script_2908,
            evh_4207795475682514_blur_2907,
            evh_4207795475682514_blur,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
    }),
    __metadata("design:type", Object)
], ExchangeRateFieldset.prototype, "value", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('value'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ExchangeRateFieldset.prototype, "onValue", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], ExchangeRateFieldset.prototype, "readonly", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('readonly'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ExchangeRateFieldset.prototype, "onReadonly", null);
ExchangeRateFieldset = __decorate([
    (0, vue_property_decorator_1.Component)()
], ExchangeRateFieldset);
exports.default = ExchangeRateFieldset;
vue_property_decorator_1.Vue.component("ExchangeRateFieldset", ExchangeRateFieldset);
